import { ActionTypes } from '../../constants/ActionTypes';
import { EditorState } from 'draft-js';
import { IDraftEditorState } from '../../interfaces';

const INIT_STATE: IDraftEditorState = {
  draftEditor: EditorState.createEmpty(),
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.CHANGE_EDITOR_DRAFT: {
      return {
        ...state,
        draftEditor: action.payload,
      };
    }

    default:
      return state;
  }
};
